var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3388 6.16916C11.3388 6.64497 10.953 7.03069 10.4772 7.03069C10.0014 7.03069 9.61569 6.64497 9.61569 6.16916C9.61569 5.69334 10.0014 5.30762 10.4772 5.30762C10.953 5.30762 11.3388 5.69334 11.3388 6.16916Z",
    fill: "#E5792C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49261 6.16916C6.49261 6.64497 6.10688 7.03069 5.63107 7.03069C5.15526 7.03069 4.76953 6.64497 4.76953 6.16916C4.76953 5.69334 5.15526 5.30762 5.63107 5.30762C6.10688 5.30762 6.49261 5.69334 6.49261 6.16916Z",
    fill: "#E5792C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 10.625C5.95833 10.0417 6.84956 9.16667 8 9.16667C9.15044 9.16667 10.0417 10.0417 10.625 10.625M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z",
    stroke: "#E5792C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.67f13a5b.svg";
export { ForwardRef as ReactComponent };